exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@font-face{font-family:thinkdev;src:url(" + require("./iconfont.woff2?t=1627269857324") + ") format(\"woff2\"),url(" + require("./iconfont.woff?t=1627269857324") + ") format(\"woff\"),url(" + require("./iconfont.ttf?t=1627269857324") + ") format(\"truetype\")}.thinkdev{font-family:thinkdev!important;font-style:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-app:before{content:\"\\E73B\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/libs/iconfont/iconfont.css
// module id = 393
// module chunks = 1